import { render, staticRenderFns } from "./WorkerInfoV2.vue?vue&type=template&id=d56dc034"
import script from "./WorkerInfoV2.vue?vue&type=script&lang=js"
export * from "./WorkerInfoV2.vue?vue&type=script&lang=js"
import style0 from "./WorkerInfoV2.vue?vue&type=style&index=0&id=d56dc034&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports